var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"mb-0"},[_vm._v(" Hotline: "),_c('a',{staticClass:"text-black",attrs:{"href":"tel:1900.63.64.88"}},[_vm._v("1900.63.64.88")]),_vm._v(" "),_c('br'),_vm._v(" Email: "),_c('a',{staticClass:"text-black",attrs:{"href":"mailto:hotro@mpos.vn"}},[_vm._v("hotro@mpos.vn")])])
}]

export { render, staticRenderFns }